import React from "react";
import {
	Text,
	View,
	StyleSheet,
	Pressable,
	FlatList,
	Image,
} from "react-native";

const spotify = require("../../assets/images/discountSpotify.png");
const apple = require("../../assets/images/discountApple.png");
const pizzaHut = require("../../assets/images/discountPizzaHut.png");

const RecommendedDiscountsRail = () => {
	const staticDiscounts = [
		{
			id: 0,
			imageSrc: spotify,
		},
		{
			id: 1,
			imageSrc: apple,
		},
		{
			id: 2,
			imageSrc: pizzaHut,
		},
	];

	return (
		<View style={styles.container}>
			<View style={styles.header}>
				<Text style={styles.headerTitle}>Descontos recomendados</Text>
				<Pressable onPress={() => alert("oi")}>
					<Text style={styles.headerReadMore}>Ver mais</Text>
				</Pressable>
			</View>
			<View>
				<FlatList
					horizontal
					data={staticDiscounts}
					ListFooterComponent={() => <View></View>}
					renderItem={({ item, index }) => (
						<View
							style={[
								styles.item,
								{
									marginLeft: index === 0 ? 24 : 0,
								},
							]}
						>
							<Image source={item.imageSrc} style={styles.image} />
						</View>
					)}
				/>
			</View>
		</View>
	);
};

export default RecommendedDiscountsRail;

const styles = StyleSheet.create({
	container: {
		marginBottom: 20,
	},
	header: {
		flexDirection: "row",
		marginBottom: 12,
		paddingHorizontal: 24,
		justifyContent: "space-between",
	},
	headerTitle: {
		fontFamily: "DmSans-bold",
		fontSize: 18,
		color: "#727683",
	},
	headerReadMore: {
		fontFamily: "DmSans-bold",
		fontSize: 14,
		color: "#0843F5",
		marginTop: 3,
	},
	item: {
		width: 222,
		height: 120,
		marginRight: 15,
		overflow: "hidden",
	},
	image: {
		flex: 1,
	},
});
